class Blog {
  constructor (data) {
    this.id = data ? data.id : ''
    this.title = data ? data.title : ''
    this.image = data ? data.image : ''
    this.imageUrl = data ? data.imageUrl : ''
    this.is_main_blog = data ? data.is_main_blog === 1 : false
    this.description = data ? data.description : ''
    this.created_at = data ? data.created_at : ''
  }

  getFormData () {
    let formData = new FormData()
    formData.append('id', this.id)
    formData.append('title', this.title)
    formData.append('image', this.image)
    formData.append('is_main_blog', this.is_main_blog === true ? 1 : 0)
    formData.append('description', this.description)
    return formData
  }
}

export default Blog



// WEBPACK FOOTER //
// ./src/models/Blog.js